<div class="input-group">
  <input
    class="form-control form-control-lg"
    [id]="key"
    [placeholder]="props.placeholder"
    [formControl]="formControl"
    ngbDatepicker
    #datePicker="ngbDatepicker"
    [class.is-invalid]="showError"
    [class.is-valid]="(formControl.dirty || formControl.touched) && !showError"
    [markDisabled]="isDateInvalid.bind(this)"
    [attr.aria-describedby]="errorId + ' ' + errorDescriptionId"
  />
  <div class="input-group-append" (click)="datePicker.toggle()">
    <span class="input-group-text bg-primary" [id]="key">
      <i class="far fa-2x fa-calendar-alt text-white"></i>
    </span>
  </div>
</div>

<div id="{{ errorDescriptionId }}" class="sr-only">
  {{ valid ? 'valid input' : '' }}
  {{ invalid ? 'invalid input' : '' }}
</div>
